import {
  GET_CURRENT_MODELS,
  SearchDefinition,
  SET_CURRENT_MODELS,
  FetchPaginatedModelsAction,
  GET_PAGINATED_MODELS,
  GET_PAGINATED_MODELS_SUCCESS,
  ModelActionTypes,
  CoreJsonMeta,
  Bucket,
  GenericMap,
  GET_BUCKETS_SUCCESS,
  CREATE_NEW_MODEL,
  SET_EDIT_MODEL_LOADING,
  GET_EDIT_MODEL_LOADING,
} from "./types";
import { Model } from "types/generatedTypes";
import { CoreJsonResponse } from "coral-utility";

export const getCurrentModels = () => ({
  type: GET_CURRENT_MODELS,
});

export const setCurrentModels = (payload: Model[]) => ({
  type: SET_CURRENT_MODELS,
  payload,
});

export const setEditModelLoading = (payload: boolean) => ({
  type: SET_EDIT_MODEL_LOADING,
  payload,
});

export const getEditModelLoading = () => ({
  type: GET_EDIT_MODEL_LOADING,
});

export const createNewModel = (payload: FormData) => ({
  type: CREATE_NEW_MODEL,
  payload,
});

export function fetchPaginatedModels(
  query: SearchDefinition
): FetchPaginatedModelsAction {
  return {
    type: GET_PAGINATED_MODELS,
    payload: query,
  };
}

export function populateStoreWithPaginatedModels(
  response: CoreJsonResponse<Model[], CoreJsonMeta>
): ModelActionTypes {
  return {
    type: GET_PAGINATED_MODELS_SUCCESS,
    payload: response,
  };
}

export function populateStoreWithBuckets(
  response: CoreJsonResponse<GenericMap<Bucket[]>, null>
): ModelActionTypes {
  return {
    type: GET_BUCKETS_SUCCESS,
    payload: response,
  };
}
